import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";

import { useHistory, useParams } from "react-router-dom";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import { ReactComponent as BreadCrumbDot } from "../../assets/icons/breadCrumbsDot.svg";
import { Button } from "../../elements/Button";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchPri.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete_icon_primary.svg";
import {ReactComponent as EditIcon} from "../../assets/icons/editWhite.svg";
import { ReactComponent as ShowIcon } from "../../assets/icons/show.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import Breadcrumb from "../../components/Breadcrumb";
import Sidebar from "../../elements/Sidebar";
import Modal from "../../elements/Modal";
import Dropdown from "../../elements/Dropdown";
import SocieConfigModal from "../../components/templateLibrary/SocieConfigModal";
import bookclosuretablecss from "../../css/bookclosuretable.module.css";
import tablecss from "../../css/table.module.css";
import libcss from "../../css/library.module.css";

import { customStyles } from "../../../Bookclosure/Components/AddTaskModal";
import InputGroup from "../../elements/InputGroup";
import CustomDropdownIndicator from "../../elements/CustomDropdownIndicator";
import saCreationcss from "../../css/standaloneCreation.module.css";

import GeneralTemplateInfo from "./GeneralTemplateInfo";
import Hierarchy from "./Hierarchy.jsx";
import Notes from "./Notes";
import Socie from "./Socie.jsx";
import Disclosures from "./Disclosures";
import CashflowWorkings from "./CashflowWorkings";
import { getTemplateDetailsApiHandler, updateCashflowWorkings } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import Cashflow from "./Cashflow";
import OverrideFSModal from "../../components/templateLibrary/OverrideFSModal";
import {ReactComponent as breadCrumbDot} from "../../assets/icons/breadCrumbsDot.svg";
import LibraryDeletedItems from "./components/LibraryDeletedItems";

const ViewEditLibrary = () => {
  const animatedComponents = makeAnimated();
  const [showPreview, setShowPreview] = useState(false);
  const handleSaveFnRef = useRef(null);
  const setHandleSaveFn = useCallback((fn) => {
    handleSaveFnRef.current = fn;
  }, []);
  const [activeTab, setActiveTab] = useState(null); 
  let history = useHistory();
  const dispatch = useDispatch();
  const [fs, setFs] = useState([]);
  //const [libraryName, setLibraryName] = useState("ST Library");
  const { tempId } = useParams();

  const [templateData, setTemplateData] = useState({});
  const [edit, setEdit] = useState(false);
  const savedTabKey = `viewEditLibraryTab_${tempId}`;
  const [tab, setTab] = useState(() => {
    const savedTab = localStorage.getItem(savedTabKey);
    return savedTab || "general";
  });
  const [showBin, setShowBin] = useState(null);
  const [showOverrideModal, setShowOverrideModal] = useState(false);
  const [showConfigureModal, setShowConfigureModal] = useState(false);
  const [handleSave, setHandleSave] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const tabNameMap = {
    general: "General",
    hierarchy: "Hierarchy",
    notes: "Notes",
    cashflow: "Cashflow",
    cashflowWorkings: "Cashflow Workings",
    socie: "SOCIE",
    disclosures: "Disclosures",
  };

  const breadcrumbItems = [
    {
      label: "Template Library",
      link: `/myfinv2/library/standalone-library`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    ...(templateData?.templateName || templateData?.name || templateData?.groupingTemplateName
      ? [{ label: templateData.templateName || templateData.name || templateData.groupingTemplateName, link: "", className: "nav_cnt_color" }] 
      : []),
    { label: tabNameMap[tab] || "Library name", link: "", className: "headerLable" },
  ];

  const socieTable = useMemo(() => {
    if (!templateData?.socie || !Array.isArray(templateData.socie)) return null;
    for (const note of templateData.socie) {
      const allNotes = [note, ...(note.subNotes || [])];
      for (const n of allNotes) {
        const found = (n.data || []).find((b) => b.dataType === "table");
        if (found) return found;
      }
    }
    return null;
  }, [templateData]);

  useEffect(() => {
    getTemplateDetails();
  }, []);

  const getTemplateDetails = () => {
    getTemplateDetailsApiHandler({ groupingTemplateID: tempId })
      .then((response) => {
        if (response?.data?.success === true) {
          let td = response?.data?.groupingTemplate;
          if (td) {
            let noteCounter = 1;
            ['generalNotes', 'BSNotes', 'PLNotes'].forEach(key => {
              if (Array.isArray(td[key])) {
                td[key].forEach(note => {
                  note.notes = noteCounter++;
                });
              }
            });
          }
          setTemplateData(td);

          // setIsReadOnly(
          //   response?.data?.groupingTemplate?.templateType === "default"
          //     ? true
          //     : false
          // );
          const isDefault =
            response?.data?.groupingTemplate?.templateType === "default";

          setIsReadOnly(isDefault);
          setEdit(!isDefault);
        }
      })
      .catch((error) => {
        // setCompanyData({});
      });
  };

  useEffect(() => {
    if (!tempId) return;
    localStorage.setItem(savedTabKey, tab);
  }, [tab, savedTabKey, tempId]);

  return (
    <>
      <div>
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className={commoncss.w100}
            style={{ maxHeight: "100vh", overflowY: "hidden" }}
          >
            {showBin && showBin !== "hierarchy" ? (
              <LibraryDeletedItems 
                showBin={showBin} 
                setShowBin={setShowBin} 
                tempId={tempId}
                templateData={templateData}
                tabName={tabNameMap[tab]}
              />
            ) : (
              <>
            <div className="fscp-header" style={{ padding: "15px 0px" }}>
              <div style={{ display: "flex", alignItems: "center", marginRight: "auto" }}>
                <Breadcrumb
                  addCls={"bgClr1"}
                  items={breadcrumbItems}
                  headerActions={<></>}
                />
                {templateData?.parentTemplateData?.name && (
                  <div style={{
                    backgroundColor: "#EAFEF5",
                    border: "1px solid #D6EBDE",
                    color: "#205a46",
                    borderRadius: "20px",
                    padding: "4px 8px",
                    fontSize: "13px",
                    fontWeight: "500",
                    marginLeft: "-15px",
                    marginTop: "7px"
                  }}>
                    {templateData.parentTemplateData.name}
                  </div>
                )}
              </div>
              {tab !== "general" && !isReadOnly && (
                <Button
                  btnColor={buttoncss.secondary_del}
                  class_={buttoncss.greyBg}
                  label={<span className={buttoncss.binLabel}>Bin</span>}
                  icon={<DeleteIcon height={18} width={18} />}
                  onClick={() => {
                    // HandleSave();
                    setShowBin(tab);
                  }}
                  // isEnabled={1 != "view" || 2 != "approver"}
                />
              )}

              {tab === "socie" && (
                <Button
                  style={{ height: "36px", background: "transparent" }}
                  btnColor={buttoncss.secondary}
                  label={"Configure"}
                  onClick={() => setShowConfigureModal(true)}
                />
              )}

              <Button
                    style={{ height: "36px", background: "transparent" }}
                    btnColor={buttoncss.secondary}
                    label={"Override"}
                    onClick={() => {setShowOverrideModal(true)}}
                    // isEnabled={1 != "view" || 2 != "approver"}
              />

               <Button
                style={{ height: "36px" }}
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label={"Preview"}
                icon={< ShowIcon height={16} width={16} />}
                onClick={() => {
                  history.push(`/myfinV2/preview-sttemplate/${tempId}`);
                }}
              />

              {!isReadOnly && (
                <>
                  <Button
                    style={{ height: "36px" }}
                    btnColor={buttoncss.primary}
                    label={"Save Changes"}
                    /*
                    label={edit ? "Save Changes" : <span> <EditIcon style={{ height: "16px", width: "16px", marginRight: "4px" }} /> Edit Changes </span>}
                    onClick={() => {
                      if (!edit) {
                        setEdit(true);
                        setIsReadOnly(false);
                      } else {
                        if (tab === "cashflowWorkings") {
                          if (typeof handleSaveFnRef.current === "function") {
                            handleSaveFnRef.current();
                          }
                        } else {
                          setHandleSave(tab);
                        }
                      }
                    }}
                    */
                    onClick={() => {
                      if (tab === "cashflowWorkings") {
                        if (typeof handleSaveFnRef.current === "function") {
                          handleSaveFnRef.current();
                        }
                      } else {
                        setHandleSave(tab);
                      }
                    }}
                  />

                  
                </>
              )}
            </div>

            <div
              className={`${libcss.libBody} m-2`}
              style={{ overflow: "hidden", width: "98%" }}
            >
              <div style={{ borderBottom: "0.5px solid #ddd" }}>
                <button
                  className={`tab-button ${tab === "general" ? "active" : ""}`}
                  style={{
                    textTransform: "capitalize",
                    borderBottom: "unset",
                  }}
                  onClick={() => {
                    setTab("general");
                  }}
                >
                  General
                </button>
                <button
                  className={`tab-button ${
                    tab === "hierarchy" ? "active" : ""
                  }`}
                  style={{
                    textTransform: "capitalize",
                    borderBottom: "unset",
                  }}
                  onClick={() => {
                    setTab("hierarchy");
                  }}
                >
                  Hierarchy
                </button>
                <button
                  className={`tab-button ${tab === "notes" ? "active" : ""}`}
                  style={{
                    textTransform: "capitalize",
                    borderBottom: "unset",
                  }}
                  onClick={() => {
                    setTab("notes");
                  }}
                >
                  Notes
                </button>
                <button
                  className={`tab-button ${tab === "cashflow" ? "active" : ""}`}
                  style={{
                    textTransform: "capitalize",
                    borderBottom: "unset",
                  }}
                  onClick={() => {
                    setTab("cashflow");
                  }}
                >
                  Cashflow
                </button>
                 <button
                  className={`tab-button ${tab === "cashflowWorkings" ? "active" : ""}`}
                  style={{
                    textTransform: "capitalize",
                    borderBottom: "unset",
                  }}
                  onClick={() => {
                    setTab("cashflowWorkings");
                  }}
                >
                  Cashflow Workings
                </button>
                <button
                  className={`tab-button ${tab === "socie" ? "active" : ""}`}
                  style={{
                    textTransform: "capitalize",
                    borderBottom: "unset",
                  }}
                  onClick={() => {
                    setTab("socie");
                  }}
                >
                  SOCIE
                </button>
                <button
                  className={`tab-button ${
                    tab === "disclosures" ? "active" : ""
                  }`}
                  style={{
                    textTransform: "capitalize",
                    borderBottom: "unset",
                  }}
                  onClick={() => {
                    setTab("disclosures");
                  }}
                >
                  Disclosures
                </button>
               
              </div>

              {tab === "general" && (
                <GeneralTemplateInfo
                  templateData={templateData}
                  setHandleSave={setHandleSave}
                  handleSave={handleSave}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "hierarchy" && templateData && (
                <Hierarchy
                  tempId={tempId}
                  showBin={showBin}
                  setShowBin={setShowBin}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "notes" && templateData && (
                <Notes
                  tempId={tempId}
                  setHandleSave={setHandleSave}
                  handleSave={handleSave}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "cashflow" && templateData && (
                <Cashflow
                  tempId={tempId}
                  setHandleSave={setHandleSave}
                  handleSave={handleSave}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "socie" && templateData && (
                <Socie
                  tempId={tempId}
                  setHandleSave={setHandleSave}
                  handleSave={handleSave}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "disclosures" && templateData && (
                <Disclosures
                  tempId={tempId}
                  setHandleSave={setHandleSave}
                  handleSave={handleSave}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "cashflowWorkings" && templateData && (
                <CashflowWorkings
                  groupingTemplateID={tempId} 
                  cashflowWorkingsID={templateData?.cashflowWorkingsID} 
                  dataID={templateData?.dataID}                       
                  isReadOnly={isReadOnly}
                  setHandleSave={setHandleSaveFn}
                  templateCashflowWorkings={templateData?.cashflowWorkings} 
                  isTemplateProp={true}
                />
              )}
            </div>
            {showOverrideModal && !isReadOnly && (
              <OverrideFSModal groupingTemplateID={tempId} setShowOverrideModal={setShowOverrideModal} />
            )}
            <SocieConfigModal
              isOpen={showConfigureModal}
              onClose={() => setShowConfigureModal(false)}
              groupingTemplateID={tempId}
              isTemplate={true}
              groupings={templateData?.grouping || []}
              socieRows={socieTable?.tableRow || []}
              socieColumns={socieTable?.tableColumn || []}
              onSaveSuccess={() => {
                getTemplateDetails();
              }}
            />
            </>
            )}
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default ViewEditLibrary;
